<script setup lang="ts">
import { useNetworkStatus } from '@/composables/useNetworkStatus'

const { isOnline } = useNetworkStatus()
</script>

<template>
  <div
    v-if="!isOnline"
    role="status"
    class="pointer-events-auto flex w-full items-center justify-center gap-2 rounded-2xl border border-outline-variant bg-surface-container-low p-3 shadow-lg"
  >
    <span
      class="material-symbols-outlined text-[18px] text-on-surface-variant"
      aria-hidden="true"
    >cloud_off</span>
    <p class="font-sans text-[13px] leading-[1.5] text-on-surface">
      You're offline. Some features may not work.
    </p>
  </div>
</template>
